export default __webpack_public_path__ + "static/russian-dolls-8c0851a12b30a961535565949431678a.jpg";